import React, { FC } from "react";

import { Radio } from "@mui/material";
import { RadioProps } from "@mui/material/Radio/Radio";
import { styled } from "@mui/material/styles";

import { ColorGray } from "./theme";

const StyledRadio = styled(Radio)(({ theme }) => ({
  color: ColorGray.main,
}));

/**
 * @see Radio
 */
export const IgRadio: FC<RadioProps> = (props) => {
  // @ts-ignore
  const { children, ...rest } = props;
  // @ts-ignore
  return <StyledRadio {...rest}>{children}</StyledRadio>;
};
